/* eslint-disable func-names */
import getPackAPIAxiosInstance from '@/axiosMieone';

const sectionMieone = {
  carton: 'carton',
  carrier: 'carrier',
  shipmethod: 'shipmethod',
  dateroll: 'carriercutoff',
};

export const searchMieone = async ({ section, params }) => {
  try {
    const filterparams = params;
    delete filterparams.page;
    const axios = getPackAPIAxiosInstance();
    const result = await axios(`${sectionMieone[section]}/`, { params: filterparams });
    return result;
  } catch (error) {
    throw error;
  }
};

export const updateMieone = async ({ section, Id, data }) => {
  try {
    const axios = getPackAPIAxiosInstance();
    const result = await axios.post(`${sectionMieone[section]}/${Id}/`, data);
    return result;
  } catch (error) {
    throw error;
  }
};

export const createMieone = async ({ section, data }) => {
  try {
    const axios = getPackAPIAxiosInstance();
    const result = await axios.post(`${sectionMieone[section]}/`, data);
    return result;
  } catch (error) {
    throw error;
  }
};

